// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"PopupVideo_buttonWrapper__yM2Gy","center":"PopupVideo_center__2s2pM","right":"PopupVideo_right__nZ207"};